import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { apiError, useChangePasswordMutation, useMeQuery } from '@/store/api'
import { Button } from '@/components/ui/button'
import { Input, Label, FieldError } from '@/components/ui/input'

const MIN_LENGTH = 12

/** Forced password change — all routes redirect here while must_change_password (design.md §5.2). */
export function ChangePassword() {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [change, { isLoading }] = useChangePasswordMutation()
  const { data: me } = useMeQuery()
  const navigate = useNavigate()

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    if (password.length < MIN_LENGTH) return setError(`Password must be at least ${MIN_LENGTH} characters.`)
    if (password !== confirm) return setError('Passwords do not match.')
    try {
      await change({ newPassword: password }).unwrap()
      toast.success('Password updated')
      navigate(me?.role === 'atarim_admin' ? '/admin/partners' : '/', { replace: true })
    } catch (err) {
      setError(apiError(err))
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted px-4">
      <div className="w-full max-w-sm rounded-xl border border-border bg-card p-6 shadow-sm">
        <h1 className="text-lg font-semibold">Set a new password</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Your password was set by an administrator. Choose a new one to continue.
        </p>
        <form onSubmit={submit} className="mt-5 space-y-4">
          <div>
            <Label htmlFor="new-password">New password</Label>
            <Input
              id="new-password"
              type="password"
              autoComplete="new-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <p className="mt-1 text-xs text-muted-foreground">At least {MIN_LENGTH} characters.</p>
          </div>
          <div>
            <Label htmlFor="confirm-password">Confirm password</Label>
            <Input
              id="confirm-password"
              type="password"
              autoComplete="new-password"
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
            />
          </div>
          <FieldError>{error}</FieldError>
          <Button type="submit" className="w-full" loading={isLoading}>
            Save and continue
          </Button>
        </form>
      </div>
    </div>
  )
}
